import React from 'react';
import classNames from 'classnames';

import css from './IconCard.module.css';

const TRASH = 'trash';
const CLOSE = 'close';
const CART = 'cart';
const SEARCH = 'search';
const NORESULT = 'noresult';
const LOCATION = 'location';
const UPLOAD = 'upload';

/**
 * Payment card icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @param {'amex' | 'diners' | 'discovery' | 'jcb' | 'mastercard' | 'unionpay' | 'visa'} props.brand payment card provider
 * @returns {JSX.Element} SVG icon
 */
const IconCard = props => {
  const { className, rootClassName, brand = 'default' } = props;
  const classes = classNames(rootClassName || css.root, className);
  const roleInfo = {
    role: 'img',
    ['aria-label']: brand,
  };

  switch (brand) {
    case UPLOAD:
      return (
        <svg
          width="100px"
          height="100px"
          viewBox="0 0 1.875 1.875"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="m0.936 0.101 0.45 0.416 -0.085 0.092L1 0.33V1.375H0.875V0.338L0.607 0.607l-0.088 -0.088zM0.25 1.625V0.875H0.125v0.875h1.625V0.875h-0.125v0.75z"
            fill="#758CA3"
          />
        </svg>
      );
    case NORESULT:
      return (
        <svg
          width="360"
          height="142"
          viewBox="0 0 360 142"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="360" height="142" rx="10" fill="#E3F0FE" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M237.06 107.489H213.483C212.826 107.489 196.69 106.11 183.101 104.72C166.368 106.06 143.439 107.489 142.717 107.489H121.94C104.863 107.489 91 93.5313 91 76.4145C91 60.1651 103.549 46.728 119.451 45.4433C119.313 44.2975 119.279 43.1865 119.279 42.0754C119.279 24.9232 133.176 11 150.219 11C162.215 11 173.139 18.0484 178.221 28.8119C183.475 25.0273 189.767 22.9788 196.266 22.9788C203.284 22.9788 210.163 25.4093 215.626 29.8188C220.569 33.8118 224.199 39.263 225.962 45.3392L237.06 45.3388C254.137 45.3388 268 59.2967 268 76.4142C268 93.5317 254.103 107.489 237.06 107.489V107.489Z"
            fill="#F2F8FF"
          />
          <path
            d="M238.69 23.3799V96.8857H187.018V23.3799H238.69Z"
            fill="#DDDDDD"
            stroke="#EEEEEE"
            stroke-width="1.18002"
          />
          <path
            d="M224.029 79.5042V96.886H202.27V79.5042H224.029Z"
            fill="#A4A4A4"
            stroke="#EEEEEE"
            stroke-width="1.18002"
          />
          <path
            d="M223.045 80.7615V96.8855H203.354V80.7615H223.045Z"
            fill="#EEEEEE"
            stroke="#EEEEEE"
            stroke-width="1.18002"
          />
          <mask id="path-6-inside-1_239_19" fill="white">
            <path d="M208.769 78.9143H207.98V97.4759H208.769V78.9143Z" />
          </mask>
          <path d="M208.769 78.9143H207.98V97.4759H208.769V78.9143Z" fill="#A4A4A4" />
          <path
            d="M207.98 78.9143V77.7343H206.8V78.9143H207.98ZM208.769 78.9143H209.949V77.7343H208.769V78.9143ZM208.769 97.4759V98.6559H209.949V97.4759H208.769ZM207.98 97.4759H206.8V98.6559H207.98V97.4759ZM207.98 78.9143V80.0943H208.769V78.9143V77.7343H207.98V78.9143ZM208.769 78.9143H207.589V97.4759H208.769H209.949V78.9143H208.769ZM208.769 97.4759V96.2959H207.98V97.4759V98.6559H208.769V97.4759ZM207.98 97.4759H209.16V78.9143H207.98H206.8V97.4759H207.98Z"
            fill="#EEEEEE"
            mask="url(#path-6-inside-1_239_19)"
          />
          <mask id="path-8-inside-2_239_19" fill="white">
            <path d="M218.318 78.9143H217.53V97.4759H218.318V78.9143Z" />
          </mask>
          <path d="M218.318 78.9143H217.53V97.4759H218.318V78.9143Z" fill="#A4A4A4" />
          <path
            d="M217.53 78.9143V77.7343H216.35V78.9143H217.53ZM218.318 78.9143H219.498V77.7343H218.318V78.9143ZM218.318 97.4759V98.6559H219.498V97.4759H218.318ZM217.53 97.4759H216.35V98.6559H217.53V97.4759ZM217.53 78.9143V80.0943H218.318V78.9143V77.7343H217.53V78.9143ZM218.318 78.9143H217.138V97.4759H218.318H219.498V78.9143H218.318ZM218.318 97.4759V96.2959H217.53V97.4759V98.6559H218.318V97.4759ZM217.53 97.4759H218.71V78.9143H217.53H216.35V97.4759H217.53Z"
            fill="#EEEEEE"
            mask="url(#path-8-inside-2_239_19)"
          />
          <mask id="path-10-inside-3_239_19" fill="white">
            <path d="M224.128 83.2366H202.187V84.0275H224.128V83.2366Z" />
          </mask>
          <path d="M224.128 83.2366H202.187V84.0275H224.128V83.2366Z" fill="#A4A4A4" />
          <path
            d="M202.187 83.2366V82.0566H201.007V83.2366H202.187ZM224.128 83.2366H225.308V82.0566H224.128V83.2366ZM224.128 84.0275V85.2075H225.308V84.0275H224.128ZM202.187 84.0275H201.007V85.2075H202.187V84.0275ZM202.187 83.2366V84.4166H224.128V83.2366V82.0566H202.187V83.2366ZM224.128 83.2366H222.948V84.0275H224.128H225.308V83.2366H224.128ZM224.128 84.0275V82.8475H202.187V84.0275V85.2075H224.128V84.0275ZM202.187 84.0275H203.367V83.2366H202.187H201.007V84.0275H202.187Z"
            fill="#EEEEEE"
            mask="url(#path-10-inside-3_239_19)"
          />
          <path
            opacity="0.5"
            d="M206.873 84.8486L203.648 93.5801V84.8486H206.873Z"
            fill="white"
            stroke="#EEEEEE"
            stroke-width="1.18002"
          />
          <path
            opacity="0.5"
            d="M205.503 80.959L203.648 82.0215V80.959H205.503Z"
            fill="white"
            stroke="#EEEEEE"
            stroke-width="1.18002"
          />
          <path
            opacity="0.5"
            d="M222.46 84.8486L219.236 93.5801V84.8486H222.46Z"
            fill="white"
            stroke="#EEEEEE"
            stroke-width="1.18002"
          />
          <path
            opacity="0.5"
            d="M221.091 80.959L219.236 82.0205V80.959H221.091Z"
            fill="white"
            stroke="#EEEEEE"
            stroke-width="1.18002"
          />
          <path
            opacity="0.5"
            d="M211.525 84.8486L209.72 92.082V84.8486H211.525Z"
            fill="white"
            stroke="#EEEEEE"
            stroke-width="1.18002"
          />
          <path
            opacity="0.5"
            d="M216.218 85.0298L214.412 92.2642V85.0298H216.218Z"
            fill="white"
            stroke="#EEEEEE"
            stroke-width="1.18002"
          />
          <path
            opacity="0.5"
            d="M213.523 80.959L209.72 82.2217V80.959H213.523Z"
            fill="white"
            stroke="#EEEEEE"
            stroke-width="1.18002"
          />
          <path
            d="M213.396 97.4759V84.0278"
            stroke="#EEEEEE"
            stroke-width="0.758869"
            stroke-miterlimit="10"
          />
          <mask id="path-20-inside-4_239_19" fill="white">
            <path d="M213.007 91.1932C213.007 91.3045 212.922 91.3943 212.816 91.3943C212.71 91.3943 212.625 91.3045 212.625 91.1932V89.3703C212.625 89.2596 212.71 89.1692 212.816 89.1692C212.922 89.1692 213.007 89.2596 213.007 89.3703V91.1932Z" />
          </mask>
          <path
            d="M213.007 91.1932C213.007 91.3045 212.922 91.3943 212.816 91.3943C212.71 91.3943 212.625 91.3045 212.625 91.1932V89.3703C212.625 89.2596 212.71 89.1692 212.816 89.1692C212.922 89.1692 213.007 89.2596 213.007 89.3703V91.1932Z"
            fill="#9A9A9A"
          />
          <path
            d="M213.007 91.1932H211.827C211.827 90.7088 212.215 90.2143 212.816 90.2143V91.3943V92.5743C213.628 92.5743 214.187 91.9002 214.187 91.1932H213.007ZM212.816 91.3943V90.2143C213.419 90.2143 213.805 90.7113 213.805 91.1932H212.625H211.445C211.445 91.8977 212.002 92.5743 212.816 92.5743V91.3943ZM212.625 91.1932H213.805V89.3703H212.625H211.445V91.1932H212.625ZM212.625 89.3703H213.805C213.805 89.8504 213.421 90.3492 212.816 90.3492V89.1692V87.9892C211.999 87.9892 211.445 88.6688 211.445 89.3703H212.625ZM212.816 89.1692V90.3492C212.213 90.3492 211.827 89.8529 211.827 89.3703H213.007H214.187C214.187 88.6663 213.63 87.9892 212.816 87.9892V89.1692ZM213.007 89.3703H211.827V91.1932H213.007H214.187V89.3703H213.007Z"
            fill="#EEEEEE"
            mask="url(#path-20-inside-4_239_19)"
          />
          <mask id="path-22-inside-5_239_19" fill="white">
            <path d="M214.128 91.1932C214.128 91.3045 214.043 91.3943 213.937 91.3943C213.832 91.3943 213.746 91.3045 213.746 91.1932V89.3703C213.746 89.2596 213.832 89.1692 213.937 89.1692C214.043 89.1692 214.128 89.2596 214.128 89.3703V91.1932Z" />
          </mask>
          <path
            d="M214.128 91.1932C214.128 91.3045 214.043 91.3943 213.937 91.3943C213.832 91.3943 213.746 91.3045 213.746 91.1932V89.3703C213.746 89.2596 213.832 89.1692 213.937 89.1692C214.043 89.1692 214.128 89.2596 214.128 89.3703V91.1932Z"
            fill="#9A9A9A"
          />
          <path
            d="M214.128 91.1932H212.948C212.948 90.7113 213.335 90.2143 213.937 90.2143V91.3943V92.5743C214.752 92.5743 215.308 91.8977 215.308 91.1932H214.128ZM213.937 91.3943V90.2143C214.54 90.2143 214.926 90.7114 214.926 91.1932H213.746H212.566C212.566 91.8976 213.123 92.5743 213.937 92.5743V91.3943ZM213.746 91.1932H214.926V89.3703H213.746H212.566V91.1932H213.746ZM213.746 89.3703H214.926C214.926 89.8503 214.543 90.3492 213.937 90.3492V89.1692V87.9892C213.12 87.9892 212.566 88.6689 212.566 89.3703H213.746ZM213.937 89.1692V90.3492C213.332 90.3492 212.948 89.8504 212.948 89.3703H214.128H215.308C215.308 88.6688 214.754 87.9892 213.937 87.9892V89.1692ZM214.128 89.3703H212.948V91.1932H214.128H215.308V89.3703H214.128Z"
            fill="#EEEEEE"
            mask="url(#path-22-inside-5_239_19)"
          />
          <path
            d="M197.733 81.0908V92.2383H191.3V81.0908H197.733Z"
            fill="#A4A4A4"
            stroke="#EEEEEE"
            stroke-width="1.18002"
          />
          <path
            d="M197.042 82.2112V91.1174H191.992V82.2112H197.042Z"
            fill="#EEEEEE"
            stroke="#EEEEEE"
            stroke-width="1.18002"
          />
          <path
            opacity="0.5"
            d="M196.084 83.0042L192.481 88.8372V83.0042H196.084Z"
            fill="white"
            stroke="#EEEEEE"
            stroke-width="1.18002"
          />
          <mask id="path-27-inside-6_239_19" fill="white">
            <path d="M194.845 80.501H194.188V92.8285H194.845V80.501Z" />
          </mask>
          <path d="M194.845 80.501H194.188V92.8285H194.845V80.501Z" fill="#A4A4A4" />
          <path
            d="M194.188 80.501V79.321H193.008V80.501H194.188ZM194.845 80.501H196.025V79.321H194.845V80.501ZM194.845 92.8285V94.0085H196.025V92.8285H194.845ZM194.188 92.8285H193.008V94.0085H194.188V92.8285ZM194.188 80.501V81.681H194.845V80.501V79.321H194.188V80.501ZM194.845 80.501H193.665V92.8285H194.845H196.025V80.501H194.845ZM194.845 92.8285V91.6485H194.188V92.8285V94.0085H194.845V92.8285ZM194.188 92.8285H195.368V80.501H194.188H193.008V92.8285H194.188Z"
            fill="#EEEEEE"
            mask="url(#path-27-inside-6_239_19)"
          />
          <mask id="path-29-inside-7_239_19" fill="white">
            <path d="M198.061 86.3352H190.973V86.9942H198.061V86.3352Z" />
          </mask>
          <path d="M198.061 86.3352H190.973V86.9942H198.061V86.3352Z" fill="#A4A4A4" />
          <path
            d="M190.973 86.3352V85.1552H189.793V86.3352H190.973ZM198.061 86.3352H199.241V85.1552H198.061V86.3352ZM198.061 86.9942V88.1742H199.241V86.9942H198.061ZM190.973 86.9942H189.793V88.1742H190.973V86.9942ZM190.973 86.3352V87.5152H198.061V86.3352V85.1552H190.973V86.3352ZM198.061 86.3352H196.881V86.9942H198.061H199.241V86.3352H198.061ZM198.061 86.9942V85.8142H190.973V86.9942V88.1742H198.061V86.9942ZM190.973 86.9942H192.153V86.3352H190.973H189.793V86.9942H190.973Z"
            fill="#EEEEEE"
            mask="url(#path-29-inside-7_239_19)"
          />
          <path
            d="M235.464 81.0908V92.2383H229.03V81.0908H235.464Z"
            fill="#A4A4A4"
            stroke="#EEEEEE"
            stroke-width="1.18002"
          />
          <path
            d="M234.772 82.2112V91.1174H229.723V82.2112H234.772Z"
            fill="#EEEEEE"
            stroke="#EEEEEE"
            stroke-width="1.18002"
          />
          <path
            opacity="0.5"
            d="M233.815 83.0042L230.212 88.8381V83.0042H233.815Z"
            fill="white"
            stroke="#EEEEEE"
            stroke-width="1.18002"
          />
          <mask id="path-34-inside-8_239_19" fill="white">
            <path d="M232.576 80.501H231.919V92.8285H232.576V80.501Z" />
          </mask>
          <path d="M232.576 80.501H231.919V92.8285H232.576V80.501Z" fill="#A4A4A4" />
          <path
            d="M231.919 80.501V79.321H230.739V80.501H231.919ZM232.576 80.501H233.756V79.321H232.576V80.501ZM232.576 92.8285V94.0085H233.756V92.8285H232.576ZM231.919 92.8285H230.739V94.0085H231.919V92.8285ZM231.919 80.501V81.681H232.576V80.501V79.321H231.919V80.501ZM232.576 80.501H231.396V92.8285H232.576H233.756V80.501H232.576ZM232.576 92.8285V91.6485H231.919V92.8285V94.0085H232.576V92.8285ZM231.919 92.8285H233.099V80.501H231.919H230.739V92.8285H231.919Z"
            fill="#EEEEEE"
            mask="url(#path-34-inside-8_239_19)"
          />
          <mask id="path-36-inside-9_239_19" fill="white">
            <path d="M235.792 86.3352H228.703V86.9942H235.792V86.3352Z" />
          </mask>
          <path d="M235.792 86.3352H228.703V86.9942H235.792V86.3352Z" fill="#A4A4A4" />
          <path
            d="M228.703 86.3352V85.1552H227.523V86.3352H228.703ZM235.792 86.3352H236.972V85.1552H235.792V86.3352ZM235.792 86.9942V88.1742H236.972V86.9942H235.792ZM228.703 86.9942H227.523V88.1742H228.703V86.9942ZM228.703 86.3352V87.5152H235.792V86.3352V85.1552H228.703V86.3352ZM235.792 86.3352H234.612V86.9942H235.792H236.972V86.3352H235.792ZM235.792 86.9942V85.8142H228.703V86.9942V88.1742H235.792V86.9942ZM228.703 86.9942H229.883V86.3352H228.703H227.523V86.9942H228.703Z"
            fill="#EEEEEE"
            mask="url(#path-36-inside-9_239_19)"
          />
          <path
            d="M200.81 52.4202V64.8909H192.047V52.4202H200.81Z"
            fill="#A4A4A4"
            stroke="#EEEEEE"
            stroke-width="1.18002"
          />
          <path
            d="M199.906 53.6609V63.6501H192.951V53.6609H199.906Z"
            fill="#EEEEEE"
            stroke="#EEEEEE"
            stroke-width="1.18002"
          />
          <path
            opacity="0.5"
            d="M198.697 54.5383L193.59 61.55V54.5383H198.697Z"
            fill="white"
            stroke="#EEEEEE"
            stroke-width="1.18002"
          />
          <mask id="path-41-inside-10_239_19" fill="white">
            <path d="M196.857 51.8303H196V65.4807H196.857V51.8303Z" />
          </mask>
          <path d="M196.857 51.8303H196V65.4807H196.857V51.8303Z" fill="#A4A4A4" />
          <path
            d="M196 51.8303V50.6503H194.82V51.8303H196ZM196.857 51.8303H198.037V50.6503H196.857V51.8303ZM196.857 65.4807V66.6608H198.037V65.4807H196.857ZM196 65.4807H194.82V66.6608H196V65.4807ZM196 51.8303V53.0103H196.857V51.8303V50.6503H196V51.8303ZM196.857 51.8303H195.677V65.4807H196.857H198.037V51.8303H196.857ZM196.857 65.4807V64.3007H196V65.4807V66.6608H196.857V65.4807ZM196 65.4807H197.18V51.8303H196H194.82V65.4807H196Z"
            fill="#EEEEEE"
            mask="url(#path-41-inside-10_239_19)"
          />
          <mask id="path-43-inside-11_239_19" fill="white">
            <path d="M201.057 58.2908H191.8V59.0202H201.057V58.2908Z" />
          </mask>
          <path d="M201.057 58.2908H191.8V59.0202H201.057V58.2908Z" fill="#A4A4A4" />
          <path
            d="M191.8 58.2908V57.1108H190.62V58.2908H191.8ZM201.057 58.2908H202.237V57.1108H201.057V58.2908ZM201.057 59.0202V60.2002H202.237V59.0202H201.057ZM191.8 59.0202H190.62V60.2002H191.8V59.0202ZM191.8 58.2908V59.4708H201.057V58.2908V57.1108H191.8V58.2908ZM201.057 58.2908H199.877V59.0202H201.057H202.237V58.2908H201.057ZM201.057 59.0202V57.8402H191.8V59.0202V60.2002H201.057V59.0202ZM191.8 59.0202H192.98V58.2908H191.8H190.62V59.0202H191.8Z"
            fill="#EEEEEE"
            mask="url(#path-43-inside-11_239_19)"
          />
          <path
            d="M235.081 52.4202V64.8909H226.318V52.4202H235.081Z"
            fill="#A4A4A4"
            stroke="#EEEEEE"
            stroke-width="1.18002"
          />
          <path
            d="M234.178 53.6609V63.6501H227.223V53.6609H234.178Z"
            fill="#EEEEEE"
            stroke="#EEEEEE"
            stroke-width="1.18002"
          />
          <path
            opacity="0.5"
            d="M232.969 54.5383L227.861 61.55V54.5383H232.969Z"
            fill="white"
            stroke="#EEEEEE"
            stroke-width="1.18002"
          />
          <mask id="path-48-inside-12_239_19" fill="white">
            <path d="M231.128 51.8303H230.271V65.4807H231.128V51.8303Z" />
          </mask>
          <path d="M231.128 51.8303H230.271V65.4807H231.128V51.8303Z" fill="#A4A4A4" />
          <path
            d="M230.271 51.8303V50.6503H229.091V51.8303H230.271ZM231.128 51.8303H232.308V50.6503H231.128V51.8303ZM231.128 65.4807V66.6608H232.308V65.4807H231.128ZM230.271 65.4807H229.091V66.6608H230.271V65.4807ZM230.271 51.8303V53.0103H231.128V51.8303V50.6503H230.271V51.8303ZM231.128 51.8303H229.948V65.4807H231.128H232.308V51.8303H231.128ZM231.128 65.4807V64.3007H230.271V65.4807V66.6608H231.128V65.4807ZM230.271 65.4807H231.452V51.8303H230.271H229.091V65.4807H230.271Z"
            fill="#EEEEEE"
            mask="url(#path-48-inside-12_239_19)"
          />
          <mask id="path-50-inside-13_239_19" fill="white">
            <path d="M235.329 58.2908H226.072V59.0202H235.329V58.2908Z" />
          </mask>
          <path d="M235.329 58.2908H226.072V59.0202H235.329V58.2908Z" fill="#A4A4A4" />
          <path
            d="M226.072 58.2908V57.1108H224.892V58.2908H226.072ZM235.329 58.2908H236.509V57.1108H235.329V58.2908ZM235.329 59.0202V60.2002H236.509V59.0202H235.329ZM226.072 59.0202H224.892V60.2002H226.072V59.0202ZM226.072 58.2908V59.4708H235.329V58.2908V57.1108H226.072V58.2908ZM235.329 58.2908H234.149V59.0202H235.329H236.509V58.2908H235.329ZM235.329 59.0202V57.8402H226.072V59.0202V60.2002H235.329V59.0202ZM226.072 59.0202H227.252V58.2908H226.072H224.892V59.0202H226.072Z"
            fill="#EEEEEE"
            mask="url(#path-50-inside-13_239_19)"
          />
          <path
            d="M217.945 52.4202V64.8909H209.183V52.4202H217.945Z"
            fill="#A4A4A4"
            stroke="#EEEEEE"
            stroke-width="1.18002"
          />
          <path
            d="M217.042 53.6609V63.6501H210.086V53.6609H217.042Z"
            fill="#EEEEEE"
            stroke="#EEEEEE"
            stroke-width="1.18002"
          />
          <path
            opacity="0.5"
            d="M215.832 54.5383L210.725 61.55V54.5383H215.832Z"
            fill="white"
            stroke="#EEEEEE"
            stroke-width="1.18002"
          />
          <mask id="path-55-inside-14_239_19" fill="white">
            <path d="M213.992 51.8303H213.135V65.4807H213.992V51.8303Z" />
          </mask>
          <path d="M213.992 51.8303H213.135V65.4807H213.992V51.8303Z" fill="#A4A4A4" />
          <path
            d="M213.135 51.8303V50.6503H211.955V51.8303H213.135ZM213.992 51.8303H215.172V50.6503H213.992V51.8303ZM213.992 65.4807V66.6608H215.172V65.4807H213.992ZM213.135 65.4807H211.955V66.6608H213.135V65.4807ZM213.135 51.8303V53.0103H213.992V51.8303V50.6503H213.135V51.8303ZM213.992 51.8303H212.812V65.4807H213.992H215.172V51.8303H213.992ZM213.992 65.4807V64.3007H213.135V65.4807V66.6608H213.992V65.4807ZM213.135 65.4807H214.315V51.8303H213.135H211.955V65.4807H213.135Z"
            fill="#EEEEEE"
            mask="url(#path-55-inside-14_239_19)"
          />
          <mask id="path-57-inside-15_239_19" fill="white">
            <path d="M218.192 58.2908H208.936V59.0202H218.192V58.2908Z" />
          </mask>
          <path d="M218.192 58.2908H208.936V59.0202H218.192V58.2908Z" fill="#A4A4A4" />
          <path
            d="M208.936 58.2908V57.1108H207.756V58.2908H208.936ZM218.192 58.2908H219.372V57.1108H218.192V58.2908ZM218.192 59.0202V60.2002H219.372V59.0202H218.192ZM208.936 59.0202H207.756V60.2002H208.936V59.0202ZM208.936 58.2908V59.4708H218.192V58.2908V57.1108H208.936V58.2908ZM218.192 58.2908H217.012V59.0202H218.192H219.372V58.2908H218.192ZM218.192 59.0202V57.8402H208.936V59.0202V60.2002H218.192V59.0202ZM208.936 59.0202H210.116V58.2908H208.936H207.756V59.0202H208.936Z"
            fill="#EEEEEE"
            mask="url(#path-57-inside-15_239_19)"
          />
          <path
            d="M200.81 32.6653V45.136H192.047V32.6653H200.81Z"
            fill="#A4A4A4"
            stroke="#EEEEEE"
            stroke-width="1.18002"
          />
          <path
            d="M199.906 33.9062V43.8945H192.951V33.9062H199.906Z"
            fill="#EEEEEE"
            stroke="#EEEEEE"
            stroke-width="1.18002"
          />
          <path
            opacity="0.5"
            d="M198.697 34.7837L193.59 41.7954V34.7837H198.697Z"
            fill="white"
            stroke="#EEEEEE"
            stroke-width="1.18002"
          />
          <mask id="path-62-inside-16_239_19" fill="white">
            <path d="M196.857 32.0754H196V45.7265H196.857V32.0754Z" />
          </mask>
          <path d="M196.857 32.0754H196V45.7265H196.857V32.0754Z" fill="#A4A4A4" />
          <path
            d="M196 32.0754V30.8954H194.82V32.0754H196ZM196.857 32.0754H198.037V30.8954H196.857V32.0754ZM196.857 45.7265V46.9065H198.037V45.7265H196.857ZM196 45.7265H194.82V46.9065H196V45.7265ZM196 32.0754V33.2555H196.857V32.0754V30.8954H196V32.0754ZM196.857 32.0754H195.677V45.7265H196.857H198.037V32.0754H196.857ZM196.857 45.7265V44.5465H196V45.7265V46.9065H196.857V45.7265ZM196 45.7265H197.18V32.0754H196H194.82V45.7265H196Z"
            fill="#EEEEEE"
            mask="url(#path-62-inside-16_239_19)"
          />
          <mask id="path-64-inside-17_239_19" fill="white">
            <path d="M201.057 38.5359H191.8V39.2659H201.057V38.5359Z" />
          </mask>
          <path d="M201.057 38.5359H191.8V39.2659H201.057V38.5359Z" fill="#A4A4A4" />
          <path
            d="M191.8 38.5359V37.3559H190.62V38.5359H191.8ZM201.057 38.5359H202.237V37.3559H201.057V38.5359ZM201.057 39.2659V40.4459H202.237V39.2659H201.057ZM191.8 39.2659H190.62V40.4459H191.8V39.2659ZM191.8 38.5359V39.7159H201.057V38.5359V37.3559H191.8V38.5359ZM201.057 38.5359H199.877V39.2659H201.057H202.237V38.5359H201.057ZM201.057 39.2659V38.0859H191.8V39.2659V40.4459H201.057V39.2659ZM191.8 39.2659H192.98V38.5359H191.8H190.62V39.2659H191.8Z"
            fill="#EEEEEE"
            mask="url(#path-64-inside-17_239_19)"
          />
          <path
            d="M235.081 32.6653V45.136H226.318V32.6653H235.081Z"
            fill="#A4A4A4"
            stroke="#EEEEEE"
            stroke-width="1.18002"
          />
          <path
            d="M234.178 33.9062V43.8945H227.223V33.9062H234.178Z"
            fill="#EEEEEE"
            stroke="#EEEEEE"
            stroke-width="1.18002"
          />
          <path
            opacity="0.5"
            d="M232.969 34.7837L227.861 41.7954V34.7837H232.969Z"
            fill="white"
            stroke="#EEEEEE"
            stroke-width="1.18002"
          />
          <mask id="path-69-inside-18_239_19" fill="white">
            <path d="M231.128 32.0754H230.271V45.7265H231.128V32.0754Z" />
          </mask>
          <path d="M231.128 32.0754H230.271V45.7265H231.128V32.0754Z" fill="#A4A4A4" />
          <path
            d="M230.271 32.0754V30.8954H229.091V32.0754H230.271ZM231.128 32.0754H232.308V30.8954H231.128V32.0754ZM231.128 45.7265V46.9065H232.308V45.7265H231.128ZM230.271 45.7265H229.091V46.9065H230.271V45.7265ZM230.271 32.0754V33.2555H231.128V32.0754V30.8954H230.271V32.0754ZM231.128 32.0754H229.948V45.7265H231.128H232.308V32.0754H231.128ZM231.128 45.7265V44.5465H230.271V45.7265V46.9065H231.128V45.7265ZM230.271 45.7265H231.452V32.0754H230.271H229.091V45.7265H230.271Z"
            fill="#EEEEEE"
            mask="url(#path-69-inside-18_239_19)"
          />
          <mask id="path-71-inside-19_239_19" fill="white">
            <path d="M235.329 38.5359H226.072V39.2659H235.329V38.5359Z" />
          </mask>
          <path d="M235.329 38.5359H226.072V39.2659H235.329V38.5359Z" fill="#A4A4A4" />
          <path
            d="M226.072 38.5359V37.3559H224.892V38.5359H226.072ZM235.329 38.5359H236.509V37.3559H235.329V38.5359ZM235.329 39.2659V40.4459H236.509V39.2659H235.329ZM226.072 39.2659H224.892V40.4459H226.072V39.2659ZM226.072 38.5359V39.7159H235.329V38.5359V37.3559H226.072V38.5359ZM235.329 38.5359H234.149V39.2659H235.329H236.509V38.5359H235.329ZM235.329 39.2659V38.0859H226.072V39.2659V40.4459H235.329V39.2659ZM226.072 39.2659H227.252V38.5359H226.072H224.892V39.2659H226.072Z"
            fill="#EEEEEE"
            mask="url(#path-71-inside-19_239_19)"
          />
          <path
            d="M217.945 32.6653V45.136H209.183V32.6653H217.945Z"
            fill="#A4A4A4"
            stroke="#EEEEEE"
            stroke-width="1.18002"
          />
          <path
            d="M217.042 33.9062V43.8945H210.086V33.9062H217.042Z"
            fill="#EEEEEE"
            stroke="#EEEEEE"
            stroke-width="1.18002"
          />
          <path
            opacity="0.5"
            d="M215.832 34.7837L210.725 41.7954V34.7837H215.832Z"
            fill="white"
            stroke="#EEEEEE"
            stroke-width="1.18002"
          />
          <mask id="path-76-inside-20_239_19" fill="white">
            <path d="M213.992 32.0754H213.135V45.7265H213.992V32.0754Z" />
          </mask>
          <path d="M213.992 32.0754H213.135V45.7265H213.992V32.0754Z" fill="#A4A4A4" />
          <path
            d="M213.135 32.0754V30.8954H211.955V32.0754H213.135ZM213.992 32.0754H215.172V30.8954H213.992V32.0754ZM213.992 45.7265V46.9065H215.172V45.7265H213.992ZM213.135 45.7265H211.955V46.9065H213.135V45.7265ZM213.135 32.0754V33.2555H213.992V32.0754V30.8954H213.135V32.0754ZM213.992 32.0754H212.812V45.7265H213.992H215.172V32.0754H213.992ZM213.992 45.7265V44.5465H213.135V45.7265V46.9065H213.992V45.7265ZM213.135 45.7265H214.315V32.0754H213.135H211.955V45.7265H213.135Z"
            fill="#EEEEEE"
            mask="url(#path-76-inside-20_239_19)"
          />
          <mask id="path-78-inside-21_239_19" fill="white">
            <path d="M218.192 38.5359H208.936V39.2659H218.192V38.5359Z" />
          </mask>
          <path d="M218.192 38.5359H208.936V39.2659H218.192V38.5359Z" fill="#A4A4A4" />
          <path
            d="M208.936 38.5359V37.3559H207.756V38.5359H208.936ZM218.192 38.5359H219.372V37.3559H218.192V38.5359ZM218.192 39.2659V40.4459H219.372V39.2659H218.192ZM208.936 39.2659H207.756V40.4459H208.936V39.2659ZM208.936 38.5359V39.7159H218.192V38.5359V37.3559H208.936V38.5359ZM218.192 38.5359H217.012V39.2659H218.192H219.372V38.5359H218.192ZM218.192 39.2659V38.0859H208.936V39.2659V40.4459H218.192V39.2659ZM208.936 39.2659H210.116V38.5359H208.936H207.756V39.2659H208.936Z"
            fill="#EEEEEE"
            mask="url(#path-78-inside-21_239_19)"
          />
          <path
            d="M240.234 71.9839V74.2642H185.475V71.9839H240.234Z"
            fill="#AFAFAF"
            stroke="#EEEEEE"
            stroke-width="1.18002"
          />
          <path
            d="M240.234 22.3909V24.6711H185.475V22.3909H240.234Z"
            fill="#AFAFAF"
            stroke="#EEEEEE"
            stroke-width="1.18002"
          />
          <path
            d="M239.825 25.8513L238.932 27.4724H186.777L185.884 25.8513H239.825Z"
            fill="#112C4D"
            stroke="#EEEEEE"
            stroke-width="1.18002"
          />
          <path
            d="M206.368 69.5048C202.73 65.8503 197.874 63.822 192.705 63.822C187.535 63.822 182.679 65.8329 179.041 69.5048C175.404 73.1768 173.385 78.0377 173.385 83.2309C173.385 88.4241 175.386 93.3026 179.041 96.957C182.679 100.612 187.535 102.64 192.705 102.64C197.874 102.64 202.73 100.629 206.368 96.957C213.887 89.3858 213.887 77.076 206.368 69.5048ZM204.523 95.1036C201.372 98.2684 197.178 100.017 192.705 100.017C188.231 100.017 184.037 98.2684 180.886 95.1036C177.736 91.9387 175.996 87.7247 175.996 83.2309C175.996 78.7371 177.736 74.5231 180.886 71.3583C184.037 68.1934 188.231 66.4448 192.705 66.4448C197.178 66.4448 201.372 68.1934 204.523 71.3583C211.032 77.8978 211.032 88.5465 204.523 95.1036Z"
            fill="#0E397E"
          />
          <path
            d="M238.254 119.216L222.172 103.042C221.437 102.307 220.547 101.747 219.568 101.405C218.588 101.063 217.545 100.947 216.515 101.066L214.2 98.7401C221.649 88.3362 220.744 73.7358 211.45 64.3811C201.111 53.9947 184.298 53.9947 173.959 64.3811C163.62 74.7675 163.62 91.6585 173.959 102.045C179.128 107.238 185.916 109.826 192.705 109.826C198.135 109.826 203.565 108.13 208.16 104.808L210.475 107.133C210.232 109.231 210.945 111.312 212.442 112.798L228.524 128.973C229.817 130.271 231.57 131 233.398 131C235.226 131 236.979 130.271 238.271 128.973C239.577 127.661 240.29 125.93 240.29 124.077C240.271 122.251 239.54 120.506 238.254 119.216ZM175.787 100.209C166.475 90.8541 166.475 75.6068 175.787 66.252C180.451 61.5659 186.56 59.2229 192.687 59.2229C198.814 59.2229 204.923 61.5659 209.588 66.252C218.899 75.6068 218.899 90.8541 209.588 100.209C200.276 109.564 185.116 109.564 175.787 100.209ZM236.409 127.137C234.738 128.815 232.023 128.815 230.369 127.137L214.287 110.98C213.778 110.466 213.407 109.831 213.209 109.133C213.011 108.436 212.993 107.7 213.156 106.993C213.205 106.779 213.199 106.556 213.138 106.344C213.077 106.133 212.964 105.941 212.808 105.787L210.249 103.216C210.284 103.181 210.301 103.146 210.319 103.111C210.702 102.762 211.102 102.447 211.467 102.062C211.833 101.695 212.146 101.31 212.494 100.926C212.529 100.891 212.581 100.873 212.599 100.838L215.157 103.409C215.471 103.723 215.923 103.863 216.358 103.758C217.803 103.426 219.282 103.863 220.327 104.895L236.409 121.069C236.806 121.467 237.122 121.94 237.337 122.46C237.552 122.981 237.663 123.539 237.663 124.103C237.663 124.666 237.552 125.225 237.337 125.745C237.122 126.266 236.806 126.739 236.409 127.137Z"
            fill="#0E397E"
          />
          <path
            d="M200.276 75.6072C200.03 75.3633 199.699 75.2266 199.354 75.2266C199.008 75.2266 198.677 75.3633 198.431 75.6072L192.705 81.36L186.978 75.6072C186.474 75.1002 185.638 75.1002 185.133 75.6072C184.629 76.1143 184.629 76.9536 185.133 77.4607L190.86 83.2309L185.133 88.9836C184.629 89.4907 184.629 90.33 185.133 90.8371C185.395 91.0994 185.725 91.2218 186.056 91.2218C186.387 91.2218 186.717 91.0994 186.978 90.8371L192.705 85.0844L198.431 90.8371C198.692 91.0994 199.023 91.2218 199.354 91.2218C199.684 91.2218 200.015 91.0994 200.276 90.8371C200.781 90.33 200.781 89.4907 200.276 88.9836L194.55 83.2309L200.276 77.4607C200.781 76.9536 200.781 76.1318 200.276 75.6072Z"
            fill="#0E397E"
          />
        </svg>
      );
    case SEARCH:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="none"
            d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
            stroke="#112C4D"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            fill="none"
            d="M20.9999 20.9999L16.6499 16.6499"
            stroke="#112C4D"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case CART:
      return (
        <svg
          fill="#000000"
          width="20px"
          height="20px"
          viewBox="0 0 0.6 0.6"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            d="m0.524 0.05 0.025 0.447a0.05 0.05 0 0 1 -0.047 0.053l-0.003 0H0.101a0.05 0.05 0 0 1 -0.05 -0.05c0 -0.001 0 -0.001 0 -0.003L0.076 0.05zm-0.4 0.05 -0.022 0.4h0.397l-0.022 -0.4zM0.175 0.15h0.05v0.063c0 0.031 0.035 0.063 0.075 0.063s0.075 -0.031 0.075 -0.063V0.15h0.05v0.063c0 0.06 -0.058 0.113 -0.125 0.113s-0.125 -0.053 -0.125 -0.113z"
          />
        </svg>
      );
    case CLOSE:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18 6L6 18"
            stroke="#1A4478"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M6 6L18 18"
            stroke="#1A4478"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case TRASH:
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="none"
            d="M2.5 5H4.16667H17.5"
            stroke="#FD6A6A"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            fill="none"
            d="M15.8346 4.9999V16.6666C15.8346 17.1086 15.659 17.5325 15.3465 17.8451C15.0339 18.1576 14.61 18.3332 14.168 18.3332H5.83464C5.39261 18.3332 4.96868 18.1576 4.65612 17.8451C4.34356 17.5325 4.16797 17.1086 4.16797 16.6666V4.9999M6.66797 4.9999V3.33323C6.66797 2.8912 6.84356 2.46728 7.15612 2.15472C7.46869 1.84216 7.89261 1.66656 8.33464 1.66656H11.668C12.11 1.66656 12.5339 1.84216 12.8465 2.15472C13.159 2.46728 13.3346 2.8912 13.3346 3.33323V4.9999"
            stroke="#FD6A6A"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            fill="none"
            d="M8.33203 9.16656V14.1666"
            stroke="#FD6A6A"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            fill="none"
            d="M11.668 9.16656V14.1666"
            stroke="#FD6A6A"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case LOCATION:
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_152_51)">
            <path
              d="M14 6.66675C14 11.3334 8 15.3334 8 15.3334C8 15.3334 2 11.3334 2 6.66675C2 5.07545 2.63214 3.54933 3.75736 2.42411C4.88258 1.29889 6.4087 0.666748 8 0.666748C9.5913 0.666748 11.1174 1.29889 12.2426 2.42411C13.3679 3.54933 14 5.07545 14 6.66675Z"
              stroke="#949494"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
              fill="none"
            />
            <path
              d="M8 8.66675C9.10457 8.66675 10 7.77132 10 6.66675C10 5.56218 9.10457 4.66675 8 4.66675C6.89543 4.66675 6 5.56218 6 6.66675C6 7.77132 6.89543 8.66675 8 8.66675Z"
              stroke="#949494"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
              fill="none"
            />
          </g>
          <defs>
            <clipPath id="clip0_152_51">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    default:
      return (
        <svg
          className={classes}
          width="29"
          height="19"
          viewBox="0 0 29 19"
          xmlns="http://www.w3.org/2000/svg"
          {...roleInfo}
        >
          <g fill="none" fillRule="evenodd">
            <path
              d="M26.58 19H2.42A2.4004 2.4004 0 0 1 0 16.62V2.38A2.4 2.4 0 0 1 2.42 0h24.16A2.4004 2.4004 0 0 1 29 2.38v14.25c-.0165 1.3216-1.0984 2.3811-2.42 2.37zM10 5.83c0-.46-.35-.83-.78-.83H3.78c-.43 0-.78.37-.78.83v3.34c0 .46.35.83.78.83h5.44c.43 0 .78-.37.78-.83V5.83z"
              fill="#DADDE2"
            />
            <path
              d="M25 15h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0H4c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1z"
              fill="#B2B6C1"
            />
          </g>
        </svg>
      );
  }
};

export default IconCard;
